import { render, staticRenderFns } from "./ot-project-details.vue?vue&type=template&id=d5022ddc&scoped=true&"
import script from "./ot-project-details.vue?vue&type=script&lang=ts&"
export * from "./ot-project-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-details.vue?vue&type=style&index=0&id=d5022ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5022ddc",
  null
  
)

export default component.exports